import { fmtDate } from "../api";
import { useLang, useT } from "../i18n";
import { Head, useApi, useShell } from "../ui";

export function Announcements() {
  const t = useT();
  const lang = useLang();
  const { data } = useApi<{ announcements: { id: string; date: string; title: string; body: string; link?: string }[] }>("/announcements");
  return (
    <>
      <Head eyebrow={t("ann.eyebrow")} title={t("nav.announcements")} />
      <div className="card"><div className="ann">{(data?.announcements ?? []).map((a) => <a key={a.id} href={`#${a.link ?? "announcements"}`}><span className="date">{fmtDate(a.date, lang)}</span><div><b>{a.title}</b><span>{a.body}</span></div>{a.link ? <span className="pill">{t(`nav.${a.link}`)}</span> : null}</a>)}</div></div>
    </>
  );
}

const FAQ: [string, string][] = [
  ["How do I change my margin on a quote?", "Use the margin slider in the Trip builder summary or in a package quote. Your tier sets the maximum."],
  ["When do I get paid?", "Half of your margin is released when your client has paid in full, the other half when the trip departs; statements on the 1st, payouts from $50."],
  ["How do I hide my margin from a client?", "Turn on Client view in the top bar before you share your screen."],
  ["Who takes the client's payment?", "Always the Getaways, on the proposal page: deposit and balance. You never collect money."],
  ["How do I reach the next tier?", "Tiers use your departed sales over the last 12 months. Track your progress in Earnings."],
];

export function Help() {
  const t = useT();
  const { me, go } = useShell();
  return (
    <>
      <Head eyebrow={t("help.eyebrow")} title={t("nav.help")} />
      <div className="two-col">
        <section className="card"><div className="card-head"><h3>Common questions</h3></div><div className="faq-s">{FAQ.map(([q, a]) => <details key={q}><summary>{q}</summary><p className="muted">{a}</p></details>)}</div></section>
        <section className="card"><div className="card-head"><h3>Talk to us</h3></div><p>{me.accountManager.name}, your account manager · {me.accountManager.email} · {me.accountManager.phone} · {me.accountManager.hours}</p><button className="btn ink" type="button" onClick={() => go("inbox")}>{t("home.am.message")}</button></section>
      </div>
    </>
  );
}
